import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/noimage.png'


const _withScopeId = n => (_pushScopeId("data-v-77ff9de4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "profile_image" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: "result.name"
}
const _hoisted_5 = {
  key: 1,
  src: "'/api/v1/image/' + profile.account.image",
  alt: "profile image"
}
const _hoisted_6 = {
  key: 0,
  class: "profile"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "ユーザーID:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "名前:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "性別:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "誕生日:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "都道府県:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "メールアドレス:", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "アカウント作成日:", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "自己紹介:", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "趣味:", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, null, -1))
const _hoisted_17 = {
  key: 1,
  class: "profile"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "ユーザーID:", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "名前:", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "性別:", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "誕生日:", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "都道府県:", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "アカウント作成日:", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "自己紹介:", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "趣味:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.profile == null)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("p", null, _toDisplayString(_ctx.msg), 1)
        ]))
      : (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.profile.account.image == null)
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : (_openBlock(), _createElementBlock("img", _hoisted_5))
          ]),
          (_ctx.mypage)
            ? (_openBlock(), _createElementBlock("dl", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("dd", null, _toDisplayString(_ctx.profile.account.id), 1),
                _hoisted_8,
                _createElementVNode("dd", null, _toDisplayString(_ctx.profile.account.name), 1),
                _hoisted_9,
                _createElementVNode("dd", null, _toDisplayString(_ctx.profile.account.gender), 1),
                _hoisted_10,
                _createElementVNode("dd", null, _toDisplayString(_ctx.profile.basic_profile == null || _ctx.profile.basic_profile.birthday == null
                            ? '未登録'
                            : _ctx.profile.basic_profile.birthday
                                  .toLocaleDateString('ja-JP', { year: 'numeric', month: '2-digit', day: '2-digit' })
                                  .replaceAll('/', '-')), 1),
                _hoisted_11,
                _createElementVNode("dd", null, _toDisplayString(_ctx.profile.basic_profile == null || _ctx.profile.basic_profile.prefecture == null
                            ? '未登録'
                            : _ctx.profile.basic_profile.prefecture), 1),
                _hoisted_12,
                _hoisted_13,
                _createElementVNode("dd", null, _toDisplayString(_ctx.profile.account.create_date
                            .toLocaleDateString('ja-JP', {
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                                hour: '2-digit',
                                minute: '2-digit',
                                second: '2-digit',
                            })
                            .replaceAll('/', '-')), 1),
                _hoisted_14,
                _createElementVNode("dd", null, _toDisplayString(_ctx.profile.profile == null || _ctx.profile.profile.self_introduction == null
                            ? ''
                            : _ctx.profile.profile.self_introduction), 1),
                _hoisted_15,
                _createElementVNode("dd", null, _toDisplayString(_ctx.profile.profile == null || _ctx.profile.profile.hobby == null ? '' : _ctx.profile.profile.hobby.join('、')), 1),
                _hoisted_16
              ]))
            : (_openBlock(), _createElementBlock("dl", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("dd", null, _toDisplayString(_ctx.profile.account.id), 1),
                _hoisted_19,
                _createElementVNode("dd", null, _toDisplayString(_ctx.profile.account.name), 1),
                _hoisted_20,
                _createElementVNode("dd", null, _toDisplayString(_ctx.profile.account.gender), 1),
                _hoisted_21,
                _createElementVNode("dd", null, _toDisplayString(_ctx.profile.basic_profile == null || _ctx.profile.basic_profile.birthday == null
                            ? '未登録'
                            : _ctx.profile.basic_profile.birthday
                                  .toLocaleDateString('ja-JP', { year: 'numeric', month: '2-digit', day: '2-digit' })
                                  .replaceAll('/', '-')), 1),
                _hoisted_22,
                _createElementVNode("dd", null, _toDisplayString(_ctx.profile.basic_profile == null || _ctx.profile.basic_profile.prefecture == null
                            ? '未登録'
                            : _ctx.profile.basic_profile.prefecture), 1),
                _hoisted_23,
                _createElementVNode("dd", null, _toDisplayString(_ctx.profile.account.create_date
                            .toLocaleDateString('ja-JP', { year: 'numeric', month: '2-digit', day: '2-digit' })
                            .replaceAll('/', '-')), 1),
                _hoisted_24,
                _createElementVNode("dd", null, _toDisplayString(_ctx.profile.profile == null || _ctx.profile.profile.self_introduction == null
                            ? ''
                            : _ctx.profile.profile.self_introduction), 1),
                _hoisted_25,
                _createElementVNode("dd", null, _toDisplayString(_ctx.profile.profile == null || _ctx.profile.profile.hobby == null ? '' : _ctx.profile.profile.hobby.join('、')), 1)
              ]))
        ]))
  ]))
}